<template>
  <n-page-header class="mainheader" justify="center">
    <template #title>
      <n-grid :cols="1">
        <n-gi>
          <n-text class="headerTitle">
            วาระผู้บริหารกรมการข้าว
          </n-text>
        </n-gi>
      </n-grid>
    </template>
    <template #avatar>
      <n-avatar
        round
        style="margin: 0 4px"
        size="large"
        src="https://firebasestorage.googleapis.com/v0/b/rice-vue-upload.appspot.com/o/pic%2FriceLogo.png?alt=media&token=3af9eacc-927e-4acc-a87c-97673b92c6e5"
      />
    </template>
    <template #extra>
      <n-space style="margin: 0 2px">
        <!--<n-tag type="success"> {{ ModeButton() }} </n-tag>-->
        <!--<n-button color="#ff69b4" @click="ChangeViewMode_v">
          {{ ViewModeButton() }}
        </n-button>-->
      </n-space>
    </template>
  </n-page-header>
  <AppProvider>
    <router-view class=""></router-view>
  </AppProvider>
  <n-layout-footer class="bga">
    <n-grid :cols="1">
      <n-gi>
        <n-gradient-text type="success">
          กลุ่มสารสนเทศภูมิศาสตร์ ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร
          ict_rd@rice.mail.go.th
        </n-gradient-text>
      </n-gi>
    </n-grid>
  </n-layout-footer>
</template>
<script>
import AppProvider from '@/components/app-provider.vue';
import { defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Helper from './util/helper';
export default defineComponent({
  components: {
    AppProvider,
  },
  setup() {
    const helper = new Helper();
    const store = useStore();
    const viewMode = ref(
      computed(() =>
        JSON.parse(JSON.stringify(store.state.viewMode)),
      ),
    );
    const Mode = ref(
      computed(() => JSON.parse(JSON.stringify(store.state.Mode))),
    );
    async function ChangeMode_v() {
      //console.log(this.Mode);
      if (this.Mode == 'PC') {
        await helper.ChangeMode('TABLET');
      } else {
        await helper.ChangeMode('PC');
      }
    }

    async function ChangeViewMode_v() {
      if (viewMode.value == 'DAY') {
        await store
          .dispatch('ChangeViewMode', 'MONTH')
          .then(() => {});
      } else {
        await store.dispatch('ChangeViewMode', 'DAY').then(() => {});
      }
    }
    function ModeButton() {
      if (Mode.value == 'PC') {
        return 'PC MODE';
      } else {
        return 'TABLET MODE';
      }
    }
    function ViewModeButton() {
      if (viewMode.value == 'DAY') {
        return 'รายวัน';
      } else {
        return 'รายเดือน';
      }
    }
    return {
      viewMode,
      Mode,
      ChangeMode_v,
      ChangeViewMode_v,
      ModeButton,
      ViewModeButton,
    };
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.full-height {
  /*height: 100%;*/
  height: 100vh;
}
.mainheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.5;
  font-size: var(--n-font-size);
  height: 50px;
  background-image: url('https://images.pexels.com/photos/158780/leaf-nature-green-spring-158780.jpeg?cs=srgb&dl=pexels-pixabay-158780.jpg&fm=jpg');
}
.headerTitle {
  color: aliceblue;
}
.n-data-table .n-data-table-th {
  background-color: aquamarine;
}
.n-data-table-tr.n-data-table-tr--striped {
  background-color: aquamarine;
}
.bga {
  background-color: #eaea7f;
  bottom: 0;
  /*position: absolute;
  bottom: 0;
  FFA8A8*/
}
</style>
